import React from "react";

const HSGCard = (props) => {
  const { headingRight, headingLeft, hideHeader, style, full } = props;

  let headingLeftClass =
    headingRight === undefined || headingRight === ""
      ? "hsg-card-header-label pageHeader-title col-md-12 col-sm-12 col-xs-12"
      : "hsg-card-header-label pageHeader-title col-md-6 col-sm-6 col-xs-6";
  let headingRightClass =
    "hsg-card-header-label text-right col-md-6 col-sm-6 col-xs-6";
  return (
    <div className={!!full ? "hsg-card-full" : "hsg-card"} style={style}>
      {!!!hideHeader && (
        <div className="hsg-card-header row">
          <div className={headingLeftClass}>{headingLeft}</div>

          <div className={headingRightClass}>{headingRight}</div>
        </div>
      )}

      {props.children}
    </div>
  );
};

export default HSGCard;
